export enum DocCreateStatus {
    AlreadyCreate = 1,
    NotCreate = 0,
}

export interface IChunksGenerator<Data> {
    index: number;
    done: boolean;
    total: number;
    fullPageCount: number;
    docCreateStatus: DocCreateStatus;
    next(): Promise<{ done: boolean; docCreateStatus: DocCreateStatus; chunk?: Data }>;
    advance(): this;
    init(total: number, fullPageCount?: number): this;
    updateTotal(total: number): this;
    updateDocCreateStatus(status: DocCreateStatus): this;
}
